import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Stack } from "@mui/material"
import { Dispatch, SetStateAction } from "react"
import { AsyncSelect, ControlledTextField } from "src/components/forms";
import { useForm } from "react-hook-form";
import { z } from "src/lib";
import { DetalleFields, DetallePutFields } from "../api/detalle-fields";
import { zodResolver } from "@hookform/resolvers/zod";
import { HttpWRC } from "../api";
import toast from "react-hot-toast";

const schemaNuevoDetalle = z.object({
    [DetalleFields.IdOperacion]: z.number(),
    [DetallePutFields.CodOperacionTipo]: z.number(),
    [DetallePutFields.Excepcion]: z.string(),

    //[DetallePutFields.CodOperacionExcepcion]: z.number(),
})

type SchemaNuevoDetalle = z.infer<typeof schemaNuevoDetalle>

type DialogNuevoDetalleProps = {
    open: boolean
    setOpen: Dispatch<SetStateAction<boolean>>
    idOperacion: number
    idPais: number
}

export const DialogNuevoDetalle = ({ open, setOpen, idOperacion, idPais }: DialogNuevoDetalleProps) => {

    const { control, handleSubmit, watch } = useForm<SchemaNuevoDetalle>({
        resolver: zodResolver(schemaNuevoDetalle),
        defaultValues: {
            [DetalleFields.IdOperacion]: idOperacion
        }
    });

    const alGuardarDetalle = (data: SchemaNuevoDetalle) => {
        const promise = HttpWRC.postDetalle(data)

        toast.promise(promise, {
            loading: 'Guardando',
            success: 'Guardado correctamente',
            error: 'Error al guardar'
        }).then(() => setOpen(false))
    }

    return (
        <Dialog open={open} maxWidth='sm' fullWidth>
            <DialogTitle>Nuevo detalle</DialogTitle>
            <DialogContent>
                <Grid container spacing={4} pt={2}>
                    <Grid item xs={12} md={6}>
                        <AsyncSelect
                            control={control}
                            name={DetallePutFields.CodOperacionTipo}
                            label='Operación'
                            loadOptions={() => HttpWRC.getTipos(idPais)}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <ControlledTextField
                            control={control}
                            name={DetallePutFields.Excepcion}
                            label='Excepción'
                            multiline
                            rows={2}
                            fullWidth
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant='text' color='primary' onClick={() => setOpen(false)}>
                    Cancelar
                </Button>
                <Button variant='contained' color='primary' onClick={handleSubmit(alGuardarDetalle)}>
                    Guardar
                </Button>
            </DialogActions>
        </Dialog>
    )
}
